import { render } from "./HeadPage.vue?vue&type=template&id=5e5bf0e9&scoped=true"
import script from "./HeadPage.vue?vue&type=script&lang=js"
export * from "./HeadPage.vue?vue&type=script&lang=js"

import "./HeadPage.vue?vue&type=style&index=0&id=5e5bf0e9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e5bf0e9"]])

export default __exports__